import SimpleBar from 'simplebar';
import $ from 'jquery'
import Utils from '@core/base/scripts/utils/utils';

export default class GlossaryNavigation{
  constructor(){
    this.container=null;
    this.$wrapper=null;
    this.simpleBar=null;
  }

  init(container){
    this.container=container;
    //
    this.$wrapper=$('.glossary-navigation__list-wrapper',this.container);
    this.$list=$('.glossary-navigation__list');
    this.simpleBar=new SimpleBar(this.$wrapper[0], { autoHide: false });
  }

}
